import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
} from "react-admin";
import {DeviceFamilyField, DoctorReferenceField, PatientReferenceField} from "../../misc/customFields";
import { SessionFilterWithDeviceFamily } from "../../misc/filters";

export const MissedSessionList = props => {
  return (
    <List {...props} filters={<SessionFilterWithDeviceFamily />} bulkActionButtons={null}>
      <Datagrid>
        <TextField source="id" />
        <DoctorReferenceField sortBy="doctor__first_name" label="Clinician" />
        <PatientReferenceField
            label="Patient"
            source="patientInfo.id"
            allowEmpty
            sortBy="patientInfo"
        />
        <DeviceFamilyField label="Device Family" />
        <TextField source="programName" label="Program" sortable={false} />
        <TextField
          source="muscleGroupName"
          label="Muscle Group"
          sortable={false}
        />
        <TextField source="type" sortable={false} />
        <DateField source="startDate" showTime />
        <DateField
          source="expectedFinishDate"
          showTime
          label="End Date (expected)"
        />
      </Datagrid>
    </List>
  );
};
